import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {useAppSelector} from '../../hooks/redux';
import {backendSelectors} from '../../redux/app/selectors';

export const LicenseCheck = () => {
  const license = useAppSelector(backendSelectors.getLicense);
  const navigate = useNavigate();

  useEffect(() => {
    if (license === false) {
      navigate('/license-check');
    }
  }, [license, navigate]);

  return null;
};
